export default __webpack_public_path__ + "assets/kyrgyzstan-flag.png";